import React, { useState, useContext } from "react";
import "../styles/Dashboard.css";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { Link } from "react-router-dom";
import ArticleIcon from "@mui/icons-material/Article";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import SearchIcon from "@mui/icons-material/Search";
import { StudentDetailsContext } from "../store/student-details";
import { Modal } from "@mui/material";
import ReceiptPageComponent from "../components/ReceiptPage";
import DescriptionIcon from "@mui/icons-material/Description";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import GroupsIcon from '@mui/icons-material/Groups';
const ReceiptPage = () => {
  const StudentContext = useContext(StudentDetailsContext);
  const [admissionId, setAdmissionId] = useState(0);
  const [isBtnClicked, setIsBtnClicked] = useState(false);
  const [showModal, handleModal] = useState(false);
  function searchDetailsHandler() {
    StudentContext.getStudentDetailsByAdmission(admissionId);
    setIsBtnClicked(true);
  }
  function GenerateReceiptHandler() {
    handleModal(!showModal);
  }
  return (
    <div className="dashboardMainDiv">
       <div className="dashboardMenu">
        <ul className="dashboardDropdownList">
          <div className="listItemContainer ">
            <li className="listItem">
              <Link className="linkItem" to="/">
                Dashboard
              </Link>
            </li>
            <li className="listItemIcon">
              <DashboardIcon />
            </li>
          </div>

          {/* <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/students">
                Students
              </Link>
            </li>
            <li className="listItemIcon">
              <SchoolIcon />
            </li>
          </div> */}

          {/* <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/analytics">
                Analytics
              </Link>
            </li>
            <li className="listItemIcon">
              <BarChartIcon />
            </li>
          </div> */}

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/bonafide">
                Bonafide
              </Link>
            </li>
            <li className="listItemIcon">
              <ArticleIcon />
            </li>
          </div>

          <div className="listItemContainer activeContainer">
            <li className="listItem">
              <Link className="linkItem" to="/receipt">
                Receipt
              </Link>
            </li>
            <li className="listItemIcon">
              <ReceiptLongIcon />
            </li>
          </div>

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/exams">
                Exams
              </Link>
            </li>
            <li className="listItemIcon">
              <DescriptionIcon />
            </li>
          </div>

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/feeDetails">
                Fee Details
              </Link>
            </li>
            <li className="listItemIcon">
              <CurrencyRupeeIcon />
            </li>
          </div>
          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/uploadAttendance">
                Attendance
              </Link>
            </li>
            <li className="listItemIcon">
              <GroupsIcon />
            </li>
          </div>

        </ul>
      </div>
      <div className="dashboardContent ">
        <div className="container dashboardContentContainer">
          <div className="row mt-5">
            <div className="col-lg-10  p-3">
              <input
                type="name"
                className="form-control"
                placeholder="enter student admission id"
                onChange={(e) => setAdmissionId(e.target.value)}
              />
              <div className="d-flex flex-row-reverse">
                <button
                  className="btn btn-sm btn-primary px-3 mt-5"
                  onClick={searchDetailsHandler}
                >
                  Search Details &nbsp; <SearchIcon />
                </button>
              </div>
            </div>
          </div>
          <div className="row d-flex flex-column">
            {isBtnClicked && StudentContext.personalDetails ? (
              <>
                <p>Check Details</p>
                <p className="text text-success">
                  {" "}
                  Name : {StudentContext.personalDetails.Name}{" "}
                </p>
                <p className="text text-success">
                  {" "}
                  FatherName : {StudentContext.personalDetails.FatherName}{" "}
                </p>
                <p className="text text-success">
                  {" "}
                  Class : {StudentContext.personalDetails.className}{" "}
                </p>
                <div className="col-lg-4">
                  <button
                    className="btn btn-sm btn-primary px-5"
                    onClick={GenerateReceiptHandler}
                  >
                    Generate Receipt
                  </button>
                </div>
              </>
            ) : (
              <></>
            )}
            {
              <Modal open={showModal}>
                <div className="receiptModal">
                  <div className="receiptModalContent">
                    <ReceiptPageComponent
                      studentName={StudentContext.personalDetails.Name}
                      className={StudentContext.personalDetails.className}
                      fatherName={StudentContext.personalDetails.FatherName}
                      currDate={new Date().toLocaleDateString()}
                      admissionId={
                        StudentContext.personalDetails.AdmissionNumber
                      }
                    />
                  </div>
                </div>
              </Modal>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReceiptPage;
